/**
 * Lightweight snapshot of the editor UI for pilot-feedback tickets.
 * Updated from the layout whenever tabs / active document change.
 * FeedbackModal reads this on submit so we do not prop-drill openTabs.
 */

export type FeedbackOpenTabSnapshot = {
  id: string
  title: string
  type: string
  filePath?: string | null
}

export type FeedbackUiContext = {
  pageUrl: string | null
  pagePath: string | null
  activeTabId: string | null
  activeTabTitle: string | null
  activeTabType: string | null
  activeDocumentPath: string | null
  openTabs: FeedbackOpenTabSnapshot[]
  updatedAt: number
}

const EMPTY: FeedbackUiContext = {
  pageUrl: null,
  pagePath: null,
  activeTabId: null,
  activeTabTitle: null,
  activeTabType: null,
  activeDocumentPath: null,
  openTabs: [],
  updatedAt: 0,
}

let snapshot: FeedbackUiContext = { ...EMPTY }

/** Called from layout when navigation state changes. */
export function setFeedbackUiContext(
  partial: Partial<Omit<FeedbackUiContext, 'pageUrl' | 'pagePath' | 'updatedAt'>>,
): void {
  const pageUrl = typeof window !== 'undefined' ? window.location.href : null
  const pagePath = typeof window !== 'undefined' ? window.location.pathname : null
  snapshot = {
    ...snapshot,
    ...partial,
    pageUrl,
    pagePath,
    updatedAt: Date.now(),
  }
}

/** Read current UI context for feedback submit (always refreshes page URL). */
export function getFeedbackUiContext(): FeedbackUiContext {
  const pageUrl = typeof window !== 'undefined' ? window.location.href : snapshot.pageUrl
  const pagePath = typeof window !== 'undefined' ? window.location.pathname : snapshot.pagePath
  return {
    ...snapshot,
    pageUrl,
    pagePath,
  }
}
